<template>
  <div class="single-box fadeIn">
    <div class="list-content">
      <div class="list-hanlder">
        <svg class="icon-svg return-icon" @click="returnList">
          <use xlink:href="#icon-youjiantou-cu" />
        </svg>
        <div class="hanlder-item">
          <a-progress class="unit-progress" type="circle" :width="40" :strokeWidth="15" :showInfo="false"
            strokeLinecap="square" trailColor="#CCCCCC" strokeColor="#FFFFFF" :percent="int.submitPercent" />
          <span>{{ int.submitPercent }}%</span>
        </div>
      </div>
      <div class="list">
        <div class="paragraph" :class="{ hide: (cint.data.length == 0) }" v-for="cint of int.children">
          <div class="cint-title">{{ cint.InductionName }}</div>
          <div class="list-item" :class="{ lastSubmit: code.isLastSubmit }" v-for="code of cint.data"
            @click="openUrl(code)" :style="{ backgroundColor: theme_color }">
            <svg class="icon-svg code-icon">
              <use :xlink:href="code.icon" />
            </svg>
            <div class="code-name">{{ code.typeName }}：{{ code.Title }}</div>
            <div class="code-hanlder">
              <svg class="icon-svg code-icon" v-if="code.isSubmited">
                <use xlink:href="#icon-duihao" />
              </svg>
              <span class="code-noSubmited" v-if="!code.isSubmited">待完成</span>
            </div>

            <a-tooltip title="帮助指引">
              <svg class="icon-svg code-help" @click.stop="chooseHelp(code)" v-if="code.configJson?.helpContent">
                <use xlink:href="#icon-help"></use>
              </svg>
            </a-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="list-describe-box">
      <div class="list-describe">
        <p class="item-unit-num">单元{{ unitNum }}</p>
        <p class="item-intname">{{ int.InductionName }}</p>
        <p class="item-des">{{ int.Description }}</p>
      </div>
    </div>
    <!-- iframe弹窗 -->
    <div class="new-popupbox" v-if="iframeUrl">
      <div class="hanlder-box">
        <svg class="icon-svg popup-close" @click="iframeUrl = ''">
          <use xlink:href="#icon-guanbi" />
        </svg>
      </div>
      <LoadingOutlined class="iframe-loading" />
      <iframe id="iframe-box" ref="iframeBox" class="box-content iframe-content" :src="iframeUrl" allowfullscreen="true"
        scrolling="no" frameborder="0" name="ifd" :style="{ backgroundColor: iframe_backcolor }"
        @load="listenIframeBox()"></iframe>
    </div>
    <HelpBox :id="helpId" @close="helpId = ''" v-if="helpId"></HelpBox>
  </div>
</template>

<script>

import showAchievement from "../../achievement/show-achievement/show-achievement.vue";
import { LoadingOutlined } from '@ant-design/icons-vue';
import HelpBox from "@/components/list/HelpBox.vue";

export default {
  components: {
    showAchievement,
    LoadingOutlined,
    HelpBox
  },
  name: "list_item",
  props: {
    int: Object
  },
  data() {
    return {
      iframeUrl: '',
      iframe_backcolor: '#ffffff00',
      backgroundImage: '',
      theme_color: '',
      helpId: '',

      unitNum: 0,
      userInfo: null,
      loading: true
    }
  },
  async mounted() {
    let { userInfo, platform } = this.$store.state;
    this.theme_color = platform.pageConfig.theme_color;
    this.userInfo = userInfo;

    //自动定位的最近提交
    setTimeout(() => {
      if ($('.lastSubmit').offset()) {
        let top = $('.lastSubmit').offset().top;
        $('.scroll-box').animate({ scrollTop: top - 110 }, 300);
      }
    }, 100);
  },
  methods: {
    //打开
    openUrl(code) {
      const token = this.userInfo.token;

      if (code.ProjectCode == 'kb') this.iframe_backcolor = '#ffffff';
      if (code.ProjectCode == "rpa" || code.ProjectCode == 'bookClass') {
        const url = code.address.replace("${token}", token)
        window.open(url);
      }
      else this.iframeUrl = code.phoneIframe;
    },
    //返回
    returnList() {
      this.$emit("returnList", true);
    },
    //监听iframe弹窗
    listenIframeBox() {
      let that = this;
      this.$nextTick(() => {
        let iframe = that.$refs["iframeBox"];
        //发送值
        iframe.contentWindow.postMessage({
          command: 'postStudentId',
          data: {
            studentId: this.userInfo.PK_UserGuid,
          },
        }, '*')
      })
    },
    //选择帮助
    chooseHelp(code) {
      this.helpId = code.configJson.helpContent.id;
    }
  },
  //beforeUnmount() {},
}
</script>

<style scoped lang="scss">
@import "./list-item.scss";
</style>